<template>
  <div class="w-full h-full overflow-hidden">
    <p class="text-xs text-gray-600 uppercase tracking-wider mb-2 dark:text-gray-300">
      {{ $t('components.reservation.availability.date.waitlist.requested') }}
    </p>
    <o-scroll class="h-full">
      <button
        v-for="date in waitlist.dates"
        :key="date.date"
        class="w-full py-1 px-2 rounded text-left text-sm mb-1 cursor-pointer transition leading-tight"
        :class="currentValue === date.date ? 'bg-blue-600 text-white dark:bg-blue-400' : 'bg-blue-100 text-blue-700 hover:bg-blue-200 dark:bg-blue-800/20 dark:text-blue-300 dark:hover:bg-blue-900/50'"
        @click="handleSetDate(date)"
      >
        <p class="font-medium">
          {{ $date.format($date.utc(new Date(date.date * 1000)), 'MMM do yyyy') }}
        </p>
        <!--<p class="opacity-75">
          {{ $date.format(date.date * 1000, 'EEEE') }}
        </p>-->
        <p class="opacity-75">
          <template v-if="date.startTime && date.endTime">
            {{ $date.minutes(date.startTime) }} - {{ $date.minutes(date.endTime) }}
          </template>
          <template v-else>
            {{ $t('waitlist.anyTime') }}
          </template>
        </p>
      </button>
    </o-scroll>
  </div>
</template>

<script setup lang="ts">
const { $date } = useNuxtApp()

interface Props {
  modelValue?: Date | null
  waitlist: Record<string, any>
}

interface Emits {
  (e: 'update:modelValue', value: any): void
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
})

const emit = defineEmits<Emits>()

const currentValue = computed({
  get () {
    const date = $date.getStartOfDayUTC(props.modelValue)
    return $date.timestamp(date)
  },
  set (value) {
    emit('update:modelValue', value)
  },
})

function handleSetDate (date: any) {
  currentValue.value = $date.utc(new Date(date.date * 1000))
}
</script>
